import React from 'react';
import { Container,Card } from './styles';

const AbsoluteDataFinantial = ({data}) => {
  return (
    <Container>
      <Card>
        <span>Inadimplêntes</span>
        <p><strong>{data?.inadimplentes}</strong></p>
      </Card>
      <Card>
        <span>Assinaturas Ativas</span>
        <p><strong>{data?.total_ativa_geral}</strong></p>
      </Card>
      <Card>
        <span>Assinaturas Criadas</span>
        <p><strong>{data?.total_criadas_periodo}</strong></p>
      </Card>
      <Card>
        <span>Assinaturas Canceladas</span>
        <p><strong>{data?.total_canceled_periodo}</strong></p>
      </Card>
      <Card>
        <span>Assinaturas Canceladas Crédito</span>
        <p><strong>{data?.quantidade_credit_canceladas}</strong></p>
      </Card>
      <Card>
        <span>Assinaturas Canceladas Boleto</span>
        <p><strong>{data?.quantidade_boleto_canceladas}</strong></p>
      </Card>
    </Container>
  );
};

export default AbsoluteDataFinantial;